import api from "./api";
import { APIS } from "../endpoints";

export const getAllAdminUsersData = async (limit, page, searchTerm) => {
    const formData = new FormData();
    formData.append('page', page);
    formData.append('limit', limit);

    if (searchTerm) {
        formData.append('search', searchTerm);
    }

    const params = new URLSearchParams(formData);
    const result = await api.get(`${APIS.BASE_URL}${APIS.adminUsers}`, {
        params: params
    });

    if (result) {
        return result?.data;
    } else {
        return [];
    }
};

export const getAdminUserData = async (id) => {
    const endpoint = `${APIS.BASE_URL}${APIS.adminUsers}/${id}`;

    try {
        const result = await api.get(endpoint);
        return result?.data?.data || [];
    } catch (error) {
        console.error('Error fetching admin user data:', error);
        return [];
    }
};

export const updateAdminUserData = async (id, data) => {
    const result = await api.put(`${APIS.BASE_URL}${APIS.adminUsers}/${id}`, data);

    if (result) {
        return result?.data;
    } else {
        return [];
    }
};

export const createNewAdminUser = async (data) => {
    const result = await api.post(`${APIS.BASE_URL}${APIS.adminUsers}`, data);

    if (result) {
        return result?.data;
    } else {
        return [];
    }
};
